export default __webpack_public_path__ + "maps-examples-camera-animation-960-23f934ce71c25485ed50d4419821c0e0.png";